export { default as SearchBar } from './hocs';
export type { SearchBarProps } from './search-bar';
export { SEARCH_BAR_HEIGHT } from './styled';
